import { Option } from '@sapphire/result';

import { ADVANCED_TARGETING_QUALIFICATION_CODE_MIN } from '../constants/survey-qualification.constants';
import {
  Qualification,
  QualificationDatum,
  RangeQualificationDatum,
  SelectableQualificationDatum,
} from '../models';

export const getQualificationName = (qualification: Qualification): string => {
  return qualification.qualificationName;
};

// Mirrors the numeric-code convention Advanced Targeting hydration uses to tell
// a targeting qualification apart from a core/location one (see
// ADVANCED_TARGETING_QUALIFICATION_CODE_MIN's own doc comment).
export const isAdvancedTargetingQualification = (
  qualification: Pick<Qualification, 'qualificationCode'>,
): boolean =>
  qualification.qualificationCode >= ADVANCED_TARGETING_QUALIFICATION_CODE_MIN;

export const getQualificationOptions = (
  qualification: Qualification,
): SelectableQualificationDatum[] => {
  return (qualification.data as SelectableQualificationDatum[]) || [];
};

export const hasCensusData = (qualification: Qualification): boolean => {
  return qualification.census.enabled && !!qualification.census.data?.length;
};

/**
 * None for a qualification that carries no range datum — `data` is empty for every
 * non-range qualification, and for a range one the backend has not populated yet.
 */
export const getQualificationRange = (
  qualification: Qualification,
): Option<RangeQualificationDatum> =>
  Option.from(qualification.data.at(0)).filter(isRangeDatum);

const isRangeDatum = (
  datum: QualificationDatum,
): datum is RangeQualificationDatum => 'min' in datum && 'max' in datum;
